package com.nnod.landing.nodin

import androidx.compose.ui.graphics.Color
import com.nnod.ui.theme.NnodBgEnd
import com.nnod.ui.theme.NnodBgStart
import com.nnod.ui.theme.NnodNodinEndAccent
import com.nnod.ui.theme.NnodNodinEndAccentDeep
import com.nnod.ui.theme.NnodNodinEndAccentSoft
import com.nnod.ui.theme.NnodNodinEndBgFrom
import com.nnod.ui.theme.NnodNodinEndBgTo
import com.nnod.ui.theme.NnodNodinEndStatusBg
import com.nnod.ui.theme.NnodNodinEndStatusDot
import com.nnod.ui.theme.NnodNodinEndStatusFg
import com.nnod.ui.theme.NnodNodinStartStatusDot
import com.nnod.ui.theme.NnodPurpleDeep
import com.nnod.ui.theme.NnodPurpleLight
import com.nnod.ui.theme.NnodPurpleMid
import com.nnod.ui.theme.NnodStatusActiveBg
import com.nnod.ui.theme.NnodStatusActiveText

enum class NodInLandingKind { START, END }

// ── State ─────────────────────────────────────────────────────────────────────

data class NodInEndState(
    val phase: NodInEndPhase = NodInEndPhase.NotFound,
)

sealed class NodInEndPhase {
    data object NotFound : NodInEndPhase()

    data class Ready(
        val campaignName: String,
        val idolName: String,
        val scheduledEndTime: String,
        val displayCode: String,
        val qrPayload: String,
        val appDeepLink: String,
    ) : NodInEndPhase()
}

// ── Labels (all user-visible strings) ─────────────────────────────────────────

data class NodInEndLabels(
    val pageTitle: String,
    val badge: String,
    val endTimeLabel: String,
    val orDivider: String,
    val codeInputLabel: String,
    val instructionsTitle: String,
    val instructionsStep1: String,
    val instructionsStep2: String,
    val openAppButton: String,
    val footer: String,
    val notFoundTitle: String,
    val notFoundBody: String,
)

// ── Per-kind theme (color tokens only, no hardcoded values) ───────────────────

data class NodInLandingTheme(
    val bgFrom: Color,
    val bgTo: Color,
    val accentColor: Color,
    val accentSoftColor: Color,
    val accentDeepColor: Color,
    val statusBgColor: Color,
    val statusFgColor: Color,
    val statusDotColor: Color,
)

fun NodInLandingKind.toTheme(): NodInLandingTheme = when (this) {
    NodInLandingKind.START -> NodInLandingTheme(
        bgFrom = NnodBgStart,
        bgTo = NnodBgEnd,
        accentColor = NnodPurpleMid,
        accentSoftColor = NnodPurpleLight,
        accentDeepColor = NnodPurpleDeep,
        statusBgColor = NnodStatusActiveBg,
        statusFgColor = NnodStatusActiveText,
        statusDotColor = NnodNodinStartStatusDot,
    )
    NodInLandingKind.END -> NodInLandingTheme(
        bgFrom = NnodNodinEndBgFrom,
        bgTo = NnodNodinEndBgTo,
        accentColor = NnodNodinEndAccent,
        accentSoftColor = NnodNodinEndAccentSoft,
        accentDeepColor = NnodNodinEndAccentDeep,
        statusBgColor = NnodNodinEndStatusBg,
        statusFgColor = NnodNodinEndStatusFg,
        statusDotColor = NnodNodinEndStatusDot,
    )
}
